import Vue from 'vue';

import {
  roundToTwo,
} from '@/utils/helper';

Vue.filter('commaFormat', (val) => `${roundToTwo(val)}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
Vue.filter('priceFormat', (val) => `$${val}`);
Vue.filter('signedPriceFormat', (val) => {
  if (+val === 0) {
    return `$${val}`;
  }
  const sign = +val > 0 ? '+' : '-';
  const value = +val > 0 ? val : val.slice(1);
  return `${sign}$${value}`;
});
